var _excluded = ["afterClose", "onOk", "onCancel"],
    _excluded2 = ["afterClose", "onOk", "onClose", "onCancel"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import React from 'react';
import ReactDOM from 'react-dom';
import { getConfig, ConfigProvider } from '@okee-uikit/react-config';
import { Alert } from './Alert';
import { Confirm } from './Confirm';

function wrapFunction(func, action) {
  return function () {
    try {
      var ret = func.apply(void 0, arguments);

      if (ret != null && _typeof(ret) === 'object' && typeof ret.then === 'function') {
        action && action();
        return ret;
      }

      return Promise.resolve(ret);
    } catch (e) {
      return Promise.reject(e);
    }
  };
}

function wrapManualModal(options) {
  var _options$onOk = options.onOk,
      onOk = _options$onOk === void 0 ? function () {
    return null;
  } : _options$onOk,
      _options$onCancel = options.onCancel,
      onCancel = _options$onCancel === void 0 ? function () {
    return null;
  } : _options$onCancel,
      footerRef = options.footerRef;
  var wrapOnOk = wrapFunction(onOk, function () {
    var _a;

    return (_a = footerRef === null || footerRef === void 0 ? void 0 : footerRef.current) === null || _a === void 0 ? void 0 : _a.showLoading();
  });
  var wrapOnCancel = wrapFunction(onCancel);
  var props;
  var container = document.createElement('div');
  document.body.appendChild(container);

  var destroy = function destroy() {
    if (container.parentNode) {
      ReactDOM.unmountComponentAtNode(container);
      document.body.removeChild(container);
    }
  };

  var handleClose = function handleClose() {
    var _a;

    (_a = props.ref.current) === null || _a === void 0 ? void 0 : _a.hide();
    setTimeout(destroy, 300);
  };

  var handleOk = function handleOk() {
    wrapOnOk().then(handleClose, function () {
      var _a;

      return (_a = footerRef === null || footerRef === void 0 ? void 0 : footerRef.current) === null || _a === void 0 ? void 0 : _a.hideLoading();
    });
  };

  var handleCancel = function handleCancel() {
    wrapOnCancel().then(handleClose, function () {
      return null;
    });
  };

  props = {
    onOk: handleOk,
    onCancel: handleCancel,
    destroy: destroy,
    container: container,
    handleClose: handleClose,
    ref: {
      current: null
    }
  };
  return props;
}

export function confirm(props) {
  var afterClose = props.afterClose,
      onOk = props.onOk,
      onCancel = props.onCancel,
      extra = _objectWithoutProperties(props, _excluded);

  var globalConfig = getConfig();
  var footerRef = React.createRef();

  var _wrapManualModal = wrapManualModal({
    onOk: onOk,
    onCancel: onCancel,
    footerRef: footerRef
  }),
      ref = _wrapManualModal.ref,
      destroy = _wrapManualModal.destroy,
      container = _wrapManualModal.container,
      handleDestroy = _wrapManualModal.handleClose,
      handleOk = _wrapManualModal.onOk,
      handleCancel = _wrapManualModal.onCancel;

  var handleAfterClose = function handleAfterClose() {
    destroy();
    afterClose === null || afterClose === void 0 ? void 0 : afterClose();
  };

  var render = function render() {
    var firsetRender = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    ReactDOM.render(React.createElement(ConfigProvider, {
      value: globalConfig
    }, React.createElement(Confirm, _objectSpread(_objectSpread({}, extra), {}, {
      defaultShow: firsetRender,
      ref: ref,
      afterClose: handleAfterClose,
      onOk: handleOk,
      onCancel: handleCancel,
      footerRef: footerRef
    }))), container);
  };

  render();
  return {
    destroy: handleDestroy,
    forceUpdate: function forceUpdate(children) {
      extra.children = children;
      render(false);
    }
  };
}
export function alert(props) {
  var afterClose = props.afterClose,
      onOk = props.onOk,
      onClose = props.onClose,
      onCancel = props.onCancel,
      extra = _objectWithoutProperties(props, _excluded2);

  var globalConfig = getConfig();

  var _wrapManualModal2 = wrapManualModal({
    onOk: onOk,
    onCancel: onCancel || onClose
  }),
      ref = _wrapManualModal2.ref,
      destroy = _wrapManualModal2.destroy,
      container = _wrapManualModal2.container,
      handleDestroy = _wrapManualModal2.handleClose,
      handleOk = _wrapManualModal2.onOk,
      handleClose = _wrapManualModal2.onCancel;

  var handleAfterClose = function handleAfterClose() {
    destroy();
    afterClose === null || afterClose === void 0 ? void 0 : afterClose();
  };

  var render = function render() {
    var firsetRender = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    ReactDOM.render(React.createElement(ConfigProvider, {
      value: globalConfig
    }, React.createElement(Alert, _objectSpread(_objectSpread({}, extra), {}, {
      defaultShow: firsetRender,
      ref: ref,
      afterClose: handleAfterClose,
      onOk: handleOk,
      onClose: handleClose
    }))), container);
  };

  render();
  return {
    destroy: handleDestroy,
    forceUpdate: function forceUpdate(children) {
      extra.children = children;
      render(false);
    }
  };
}